import type { UpcomingCommission } from '@sorrem/shared';
import { useGetUpcomingCommissionsQuery } from '@sorrem-client/ui/store';
import { useCurrentCharacterArgs } from './use-current-character-id';

export interface UpcomingCommissionsState {
    /** What the current character still needs for each commission they're working toward. */
    upcoming: readonly UpcomingCommission[];
    isLoading: boolean;
}

const NO_UPCOMING: readonly UpcomingCommission[] = [];

/**
 * The commissions the current character is working toward (see
 * docs/gameplay/commissions.md), such as the Mill Road's Crucible victories
 * once the intro commission is complete.
 */
export function useUpcomingCommissions(): UpcomingCommissionsState {
    // Refetch on mount: a run can win a Crucible while this is cached.
    const { data, isLoading } = useGetUpcomingCommissionsQuery(useCurrentCharacterArgs(), { refetchOnMountOrArgChange: true });
    return { upcoming: data ?? NO_UPCOMING, isLoading };
}
